export default {
  width: 30,
  height: 30,
  svg: `
  <rect x="1" y="1" width="28" height="28" rx="14" fill="#F9F9F9" stroke="#9F9FB3" stroke-width="2" stroke-linejoin="round"/>
  <rect x="7" y="7" width="16" height="16" rx="8" fill="#EF5185"/>
`
}
